// extracted by mini-css-extract-plugin
export var alertIcon = "_pj-0";